const MIXPANEL_ITEM_SEARCH_TERM_STORAGE_KEY = 'mixpanel:item-search-term'

const isBrowser = () => typeof window !== 'undefined'

export const setMixpanelItemSearchTerm = (searchTerm: string) => {
  if (!isBrowser()) return

  const trimmedSearchTerm = searchTerm.trim()
  if (!trimmedSearchTerm) return

  window.sessionStorage.setItem(MIXPANEL_ITEM_SEARCH_TERM_STORAGE_KEY, trimmedSearchTerm)
}

export const getMixpanelItemSearchTerm = (): string | null => {
  if (!isBrowser()) return null
  const searchTerm = window.sessionStorage.getItem(MIXPANEL_ITEM_SEARCH_TERM_STORAGE_KEY)
  window.sessionStorage.removeItem(MIXPANEL_ITEM_SEARCH_TERM_STORAGE_KEY)
  return searchTerm
}
